/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiMovementOrder.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-movement-order";

export class AutogenModelEdiMovementOrder<RowType extends ModelRow> extends Endpoint<RowType, RowEdiMovementOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiMovementOrder extends ModelRow<RowEdiMovementOrderFields> {
	constructor(values?: Partial<RowEdiMovementOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiMovementOrderFields {
	"edi_movement_order.accepted_date": Date;
	"edi_movement_order.brokered_sequence": number;
	"edi_movement_order.company_id": string;
	"edi_movement_order.id": string;
	"edi_movement_order.intercompany_key": string;
	"edi_movement_order.receiving_company_id": string;
	"edi_movement_order.receiving_company_move_id": string;
	"edi_movement_order.receiving_company_order_id": string;
	"edi_movement_order.sending_company_id": string;
	"edi_movement_order.sending_company_move_id": string;
	"edi_movement_order.sending_company_order_id": string;
	"edi_movement_order.settled_date": Date;
	"edi_movement_order.shipment_id": string;
	"edi_movement_order.submitted_date": Date;
}

